module.exports = __webpack_public_path__ + "095181858eadecbcf282dd3d29bdbfdd.svg";